import { MapPin, Phone, Mail, Instagram, Facebook, Youtube, ShoppingBag, ShoppingCartIcon } from "lucide-react";
import { siteData } from "../../data/siteData";
import "./Footer.css";

export default function Footer() {
  const { company, nav } = siteData;
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">

          <div className="footer__brand">
            <div className="footer__logo">
              <div className="footer__logo-leaf">🌿</div>
              <div>
                <div className="footer__logo-name">Gemburin Sejahtera</div>
                <div className="footer__logo-sub">Kontraktor Penghijauan</div>
              </div>
            </div>
            <p className="footer__tagline">Solusi penghijauan profesional untuk perkotaan, industri, dan hunian di seluruh Indonesia.</p>
            <div className="footer__socials">
              <a href={company.instagram}><Instagram size={16} /></a>
              <a href={company.facebook}><Facebook size={16} /></a>
              <a href={company.shopee}><ShoppingCartIcon size={16} /></a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Navigasi</h4>
            <ul>{nav.map(n => <li key={n.href}><a href={n.href}>{n.label}</a></li>)}</ul>
          </div>

          <div className="footer__col">
            <h4>Layanan</h4>
            <ul>
              <li><a href="#layanan">Landscape Taman</a></li>
              <li><a href="#layanan">Penghijauan & Reboisasi</a></li>
              <li><a href="#layanan">Suplai Bibit & Pohon</a></li>
              <li><a href="#kontak">Konsultasi Gratis</a></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Kontak</h4>
            <div className="footer__contacts">
              <div className="footer__ci"><MapPin size={15}/><span>{company.address}</span></div>
              <div className="footer__ci"><Phone size={15}/><a href={`tel:${company.phone}`}>{company.phone}</a></div>
              <div className="footer__ci"><Mail size={15}/><a href={`mailto:${company.email}`}>{company.email}</a></div>
            </div>
            <a href={company.whatsapp} className="footer__wa" target="_blank" rel="noreferrer">💬 Chat WhatsApp</a>
          </div>

        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <p>© 2026 Gemburin Sejahtera. Hak Cipta Dilindungi.</p>
          <p>Branggahan, Ngadiluwih, Kediri, Jawa Timur</p>
        </div>
      </div>
    </footer>
  );
}
